import React, { useEffect, useState } from "react";
import classes from "./installAppBanner.module.css";
import { AiOutlineClose } from "@react-icons/all-files/ai/AiOutlineClose";
import { GooglePlayButton } from "react-mobile-app-button";
import {
  INSTALL_APP_BANNER_TIME,
  INSTALL_APP_BANNER_VISIBLE,
} from "../../../constant/constant";

function InstallAppBanner() {
  const [displayAppInstall, setDisplayAppInstall] = useState(
    INSTALL_APP_BANNER_VISIBLE
  );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDisplayAppInstall(false);
    }, INSTALL_APP_BANNER_TIME);
    return () => clearTimeout(timeoutId);
  }, []);

  if (!displayAppInstall) return null;
  return (
    <div className={classes.root}>
      <span
        className={classes.closeButton}
        onClick={() => setDisplayAppInstall(false)}
      >
        <AiOutlineClose style={{ fontSize: 18 }} />
      </span>
      <GooglePlayButton
        url={
          "https://play.google.com/store/apps/details?id=com.ducju.gradeptit"
        }
        theme={"light"}
        title={"Tải app Grade Tool"}
      />
    </div>
  );
}

export default InstallAppBanner;
